// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// ReturnCodes Module

// The Server responds to requests with specific return (or status) codes.
// This module mirrors the return codes from the Server.  Needless to say,
// this module needs to be kept in sync with the Server.

define('ReturnCodes',['require'],function (require) {
    'use strict';

    // Constructor
    function ReturnCodes () {
    };

    // Get the numeric value of the specified return code identifier
    ReturnCodes.prototype.getCode = function (identifier) {
        return this.returnCode[identifier];
    };

    // Error codes from the Server (keep in sync!)
    ReturnCodes.prototype.returnCode = Object.freeze({
        UNSUPPORTED_REQUEST_RC: -1,
        SUCCESS_RC: 0,
        UNABLE_TO_COMPLETE_REQUEST_RC: 1,
        UNSPECIFIED_ERROR_RC: 2,
        INVALID_PARAMETER_RC: 3,
        INVALID_DEVICE_RC: 4,
        INVALID_LOGIN_RC: 100,
        USER_ALREADY_EXISTS_RC: 101,
        USER_NOT_ALLOWED_RC: 102,
        USER_NOT_FOUND_RC: 103,
        UPDATE_FAILED_RC: 105,
        NO_SCORE_SUPPLIED_RC: 200,
        INVALID_SCORE_RC: 201,
        SCORE_ALREADY_EXISTS_RC: 202,
        TOO_SOON_TO_CHECK_IN_RC: 300,
        INVALID_FAQS_RC: 400,
        INVALID_MOTD_RC: 500,
        INVALID_POLICIES_RC: 600
    });

    // Return Constructor
    return ReturnCodes.prototype.constructor;
});

